import FocusManagement from './components/FocusManagement';

function init() {
  const navToggle = document.getElementById('header__hamburgerToggle');
  navToggle && navToggle.addEventListener('click', toggleHamburger);
}

function toggleHamburger() {
  const body = document.body;
  const bodyClassList = body.classList;
  const isOpen = bodyClassList.toggle('body--headerHamburgerOpen');
  const siteHeaderEl = document.querySelector('.siteHeader');
  
  // reflow
  void(body.offsetHeight);
  
  if (isOpen) {
    FocusManagement.enableFocusTrap(siteHeaderEl, false);
    FocusManagement.onEsc(toggleHamburger);
  }
  else {
    FocusManagement.disableFocusTrap(siteHeaderEl, false);
    FocusManagement.offEsc(toggleHamburger);
  }
}

export default { init };